import { ConfirmBooking } from './confirm_booking';

export default ConfirmBooking;
